module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2fa"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01"
    }
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("2009: My Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part02"
    }
  }, [_vm._v("Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_vm._v("2001: Graduation Brunch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03"
    }
  }, [_vm._v("Empty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forsythia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1985: Wound I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Classroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jaison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puzzle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1986: Wound II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Touchstone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thursday Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Detention")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jaison II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1986: Wound III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“For Jaison”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unwrapping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wound IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Knight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1995: Leaving Jaison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guardian Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2000: Losing Jaison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wound 4.5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nothing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guardian Angel II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wound V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Inflicted Wounds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outside")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Explaining")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1989: Roommate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2000: Remembering Jaison")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1991: Road tripping with Ryl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fixer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dear Reggie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hungry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1992: Saving Ryl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camden Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1992: With Reggie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pygmalion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1992: Jesus and Judas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Langston")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lunch after Langston")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1992: After the Tone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forsythia II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snatches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Half-birthday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opportunity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jaison’s Tribute")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mom’s Call")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recital")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ryl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reunited")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questioning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Statement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Throb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hiding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crush")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2011: Epilogue")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 63
// module chunks = 0